import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '1880625795940159');
(window as any).fbq('track', 'PageView');
render(<App data-id="element-228" />, document.getElementById('root'));